import { supabase } from '@/lib/supabase/client';
import { User } from '@/types/auth';

export const fetchUsers = async () => {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('status', 'active')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
};

export const updateUserProfile = async (userId: string, data: Partial<User>) => {
  const { error } = await supabase
    .from('users')
    .update({
      ...data,
      updated_at: new Date().toISOString()
    })
    .eq('id', userId);

  if (error) throw error;
};

export const deactivateUser = async (userId: string) => {
  const { error } = await supabase
    .from('users')
    .update({ 
      status: 'inactive',
      updated_at: new Date().toISOString()
    })
    .eq('id', userId);

  if (error) throw error;
};